import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANG, NAMESPACES, SUPPORTED_LANGS } from '@shared/config';
import { RESOURCES } from '@shared/i18n';

/**
 * i18next bootstrap. Constants (SUPPORTED_LANGS, DEFAULT_LANG,
 * NAMESPACES) live in shared/config/i18n.ts so they can be imported
 * from any layer without pulling in the side-effecting init.
 *
 * The routable set is the marketing site's live locales (DIT-399); the bundle
 * backing each one is resolved in shared/i18n/locales/index.ts. Locales without
 * native copy fall back to English via `fallbackLng`.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    ns: NAMESPACES as unknown as string[],
    defaultNS: 'common',
    // Region-suffixed codes ("fr-be", "en-be") must resolve against a resource
    // key of the SAME casing. i18next otherwise reformats "fr-be" → "fr-BE" when
    // it resolves, misses the lower-cased bundle and silently serves English —
    // which is exactly what `/fr-be/plan` did before this was pinned. The
    // registry codes are all lower-case; `<html lang>` uses the registry's
    // separate `htmlLang` ("fr-BE"), unaffected. Mirrors the same setting in
    // src/marketing/i18n/instances.ts.
    lowerCaseLng: true,
    interpolation: { escapeValue: false },
    detection: {
      // URL path-prefix is the source of truth, then localStorage.
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0,
    },
    resources: RESOURCES,
  });

export default i18n;
